module.exports = __webpack_public_path__ + "static/img/250_TO8_2236.3819697.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/250_TO8_2236.jpg
// module id = YfHz
// module chunks = 0